// Cover blocks


// Set the SVG color to match the background color of the cover block
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.wp-block-cover').forEach((cover) => {
		const bg = cover.querySelector('.wp-block-cover__background');
		const svg = cover.querySelector('.tick-circle-svg');

		if (bg) {
			const bgColor = window.getComputedStyle(bg).backgroundColor;
			cover.style.setProperty('--tick-circle-fill', bgColor);
		}

		// Check if the cover has a defined custom tick path stroke
		const computed = window.getComputedStyle(cover);
		const strokeColor = computed.getPropertyValue('--tick-line-stroke');

		if (strokeColor) {
			// Apply for linear styles (mask-based)
			cover.style.setProperty('--tick-line-stroke', strokeColor.trim());

			// Apply for SVG if present
			if (svg) {
				svg.style.setProperty('--tick-line-stroke', strokeColor.trim());
			}
		}
	});

	// Parallax scrolling effect for cover blocks with parallax style
	const parallaxCovers = document.querySelectorAll('.wp-block-cover.is-style-parallax');
	
	if (parallaxCovers.length > 0) {
		const handleParallax = () => {
			const scrollY = window.scrollY || window.pageYOffset;
			const parallaxMultiplier = 0.5; // Adjust for parallax intensity
			
			parallaxCovers.forEach((cover) => {
				const bgImage = cover.querySelector('.wp-block-cover__image-background');
				if (!bgImage) return;

				const rect = cover.getBoundingClientRect();
				
				if (rect.bottom >= 0 && rect.top <= window.innerHeight) {
					bgImage.style.transform = `translateY(${scrollY * parallaxMultiplier}px)`;
				}
			});
		};

		let ticking = false;
		const onScroll = () => {
			if (!ticking) {
				window.requestAnimationFrame(() => {
					handleParallax();
					ticking = false;
				});
				ticking = true;
			}
		};

		handleParallax();
		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', handleParallax, { passive: true });
	}
});


